var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useCallback, useContext, useEffect, useMemo, useReducer, useState, } from 'react';
import kfetch from '@kareo/kfetch';
import styled from 'styled-components';
import { Alert, Box, Button, Card, CardContent, Checkbox, Divider, Radio, RadioGroup, Snackbar, TextField, ThemeProvider, } from '@kareo/design-system';
import { createTerminalTransaction, FeatureToggles, finalizeHostedPayment, SecurityFooter, TebraTerminalError, TebraTerminalErrorType, TerminalConnectionStatus, receiptUtils, } from '@kareo/billing-system';
import getDesignSystemTheme from 'shared-assets/lib/utils/getDesignSystemTheme';
import rollbar from 'shared-assets/src/errors/errors';
import { authenticatedUser } from 'shared-assets/lib/sdk/authenticatedUser';
import { FormControl, FormControlLabel, FormGroup, Typography, } from '@material-ui/core';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import FeatureToggle from 'shared-assets/components/FeatureToggle';
import { defaults } from 'shared-assets/lib/colors';
import CardDetailsSection from './CardDetailsSection';
import useTransactionSetupId from './useTransactionSetupId';
import CardDetailsContext from './CardDetailsContext';
import useSavedCards from './useSavedCards';
import portal from '../CardOnFile/portalConfig';
import featureToggles from '../../../lib/sdk/featureToggles';
var Form = styled.form(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-gap: 1rem;\n"], ["\n  display: grid;\n  grid-gap: 1rem;\n"])));
var BillingAddressForm = styled(Form)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  grid-template-columns: 20rem 5rem;\n"], ["\n  grid-template-columns: 20rem 5rem;\n"])));
var ButtonWithBlueText = styled(Button)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: var(--primary-color-dark, ", ");\n"], ["\n  color: var(--primary-color-dark, ", ");\n"])), defaults.primaryColorDark);
var NoteTextArea = styled(TextField)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 100%;\n\n  .MuiOutlinedInput-multiline {\n    padding: 0;\n  }\n"], ["\n  width: 100%;\n\n  .MuiOutlinedInput-multiline {\n    padding: 0;\n  }\n"])));
var CardDivider = styled(Divider)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  height: 1px !important; // override .kareo hr\n"], ["\n  height: 1px !important; // override .kareo hr\n"])));
var Iframe = styled.iframe(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  border: none;\n  width: 100%;\n  height: 16rem;\n"], ["\n  border: none;\n  width: 100%;\n  height: 16rem;\n"])));
var FailedTransactionStatuses = new Set([
    'FAILED_CVV_CHECK',
    'FAILED_AVS_CHECK',
    'FAILED_VALIDATION',
    'FAILED',
]);
var formatAmount = function (pendingAmountToValidate) {
    var parsedAmount = Number(pendingAmountToValidate);
    if (isNaN(parsedAmount) ||
        pendingAmountToValidate.length === 0 ||
        parsedAmount < 0) {
        return '0.00';
    }
    return parsedAmount.toFixed(2);
};
export default function CollectPayment(props) {
    return (React.createElement(React.Fragment, null,
        React.createElement(FeatureToggle, { if: "!dark-feature.tebra-payfac-card-on-file" },
            React.createElement(CollectPaymentOld, __assign({}, props))),
        React.createElement(FeatureToggle, { if: "dark-feature.tebra-payfac-card-on-file" },
            React.createElement(CollectPaymentNew, __assign({}, props))),
        React.createElement(Box, { marginLeft: "auto", marginTop: 2 },
            React.createElement(SecurityFooter, null))));
}
function CollectPaymentOld(props) {
    var patient = props.patient, patientBalance = props.patientBalance, address1 = props.address1, zip = props.zip, onConfirmTransaction = props.onConfirmTransaction, onUpdateNote = props.onUpdateNote, onFinalizePayment = props.onFinalizePayment;
    var dsTheme = getDesignSystemTheme();
    var _a = useState(Number(patientBalance).toString()), amount = _a[0], setAmount = _a[1];
    var _b = useState(Number(patientBalance !== null && patientBalance !== void 0 ? patientBalance : 0).toFixed(2)), pendingAmount = _b[0], setPendingAmount = _b[1];
    var _c = useState('credit'), selectedPaymentMethod = _c[0], setSelectedPaymentMethod = _c[1];
    var _d = useState(false), preventCreditCharge = _d[0], setPreventCreditCharge = _d[1];
    var _e = useState(''), note = _e[0], setNote = _e[1];
    var _f = useState(false), showingNote = _f[0], setShowingNote = _f[1];
    var _g = useState(true), billingAddressSameAsPatientAddress = _g[0], setBillingAddressSameAsPatientAddress = _g[1];
    var _h = useState(address1), billingAddress1 = _h[0], setBillingAddress1 = _h[1];
    var _j = useState(zip), billingZip = _j[0], setBillingZip = _j[1];
    var _k = useState(props.name), name = _k[0], setName = _k[1];
    var handleChangePaymentMethod = useCallback(function (event) {
        setSelectedPaymentMethod(event.target.value);
        if (event.target.value !== 'credit') {
            setPreventCreditCharge(true);
        }
    }, [setSelectedPaymentMethod]);
    var handleChangePreventCreditCharge = useCallback(function (event) {
        setPreventCreditCharge(event.target.checked);
    }, [setPreventCreditCharge]);
    var resetBillingAddress = useCallback(function () {
        setBillingAddressSameAsPatientAddress(true);
        setBillingAddress1(address1);
        setBillingZip(zip);
        setName(name);
    }, [address1, zip, name]);
    var handleChangeBillingAddressSame = useCallback(function (event) {
        var checked = event.target.checked;
        if (checked) {
            resetBillingAddress();
        }
        setBillingAddressSameAsPatientAddress(checked);
    }, [setBillingAddressSameAsPatientAddress, resetBillingAddress]);
    var options = useMemo(function () {
        var address = typeof billingAddress1 === 'string' ? billingAddress1 : '';
        var zip = typeof billingZip === 'string' ? billingZip : '';
        var charge = typeof amount === 'string' ? amount : '0.00';
        return {
            amount: formatAmount(charge),
            name: name !== null && name !== void 0 ? name : '',
            billingAddress1: address !== null && address !== void 0 ? address : '',
            billingZipcode: zip !== null && zip !== void 0 ? zip : '',
            cardAccountId: patient.patientId,
        };
    }, [amount, billingAddress1, billingZip]);
    var _l = useTransactionSetupId(options), transactionSetupId = _l.transactionSetupId, firstLoad = _l.firstLoad;
    useEffect(function () {
        window.addEventListener('message', function (event) {
            if (event.origin.match(/api-payments-svcs.cloud.tebra.com/i) !== null) {
                //= == payFacUrl) {
                onConfirmTransaction(event.data);
            }
        });
    }, []);
    return (React.createElement(ThemeProvider, { theme: dsTheme },
        React.createElement(Card, null,
            React.createElement(CardContent, null,
                React.createElement(Box, null,
                    React.createElement(Typography, { variant: "h3" }, "Collect Payment"),
                    React.createElement(Form, { noValidate: true, autoComplete: "off" },
                        React.createElement(Box, { display: "block" },
                            React.createElement(TextField, { value: pendingAmount, label: "Amount", type: "text", margin: "dense", inputProps: {
                                    inputMode: 'decimal',
                                }, onChange: function (e) {
                                    setPendingAmount(e.target.value);
                                }, onBlur: function () {
                                    var newAmount = formatAmount(pendingAmount);
                                    setPendingAmount(newAmount);
                                    setAmount(newAmount);
                                } })),
                        React.createElement(Box, { display: "block" },
                            !showingNote && (React.createElement(ButtonWithBlueText, { variant: "text", startIcon: React.createElement(NoteAddIcon, null), onClick: function () { return setShowingNote(true); } }, "Add Payment Note")),
                            showingNote && (React.createElement(Box, null,
                                React.createElement(Box, { display: "flex", flexDirection: "column", alignItems: "flex-start" },
                                    React.createElement(ButtonWithBlueText, { variant: "text", startIcon: React.createElement(NoteAddIcon, null), onClick: function () {
                                            onUpdateNote('');
                                            setShowingNote(false);
                                        } }, "Remove Note"),
                                    React.createElement(NoteTextArea, { multiline: true, value: note, onChange: function (event) {
                                            var value = event.target.value;
                                            setNote(value);
                                            onUpdateNote(value);
                                        } }),
                                    React.createElement(Typography, { variant: "caption" }, "This note is only visible to the practice.")))))))),
            React.createElement(CardDivider, null),
            React.createElement(CardContent, null,
                React.createElement(Typography, { variant: "h3" }, "Payment Method"),
                React.createElement(FormControl, { component: "fieldset" },
                    React.createElement(RadioGroup, { row: true, "aria-label": "selected-payment-method", name: "selectedPaymentMethod", value: selectedPaymentMethod, onChange: handleChangePaymentMethod },
                        React.createElement(FormControlLabel, { "data-testid": "credit-radio-button", labelPlacement: "end", value: "credit", control: React.createElement(Radio, null), label: "Credit Card" }),
                        React.createElement(FormControlLabel, { "data-testid": "cash-radio-button", labelPlacement: "end", value: "cash", control: React.createElement(Radio, null), label: "Cash" }),
                        React.createElement(FormControlLabel, { "data-testid": "check-radio-button", labelPlacement: "end", value: "check", control: React.createElement(Radio, null), label: "Check" })),
                    selectedPaymentMethod === 'credit' && (React.createElement(React.Fragment, null,
                        React.createElement(FormGroup, null,
                            React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: preventCreditCharge, onChange: handleChangePreventCreditCharge }), label: "Do not charge credit card. For recording purposes only." })))))),
            React.createElement(CardDivider, null),
            React.createElement(CardContent, null,
                React.createElement(Typography, { variant: "h3" }, "Billing Address"),
                React.createElement(React.Fragment, null,
                    React.createElement(FormGroup, null,
                        React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: billingAddressSameAsPatientAddress, onChange: handleChangeBillingAddressSame }), label: "Billing address is same as patient address" })),
                    !billingAddressSameAsPatientAddress && (React.createElement(BillingAddressForm, null,
                        React.createElement(TextField, { margin: "dense", label: "Address", defaultValue: address1 }),
                        React.createElement(TextField, { margin: "dense", label: "Zip", defaultValue: zip, inputProps: { maxLength: 5 } }))))),
            React.createElement(CardDivider, null),
            !preventCreditCharge && firstLoad && (React.createElement(CardContent, null,
                React.createElement(Typography, { variant: "h3" }, "Card Details"),
                React.createElement(Box, null,
                    React.createElement(Iframe, { title: "Payment", height: "750rem", width: "100%", src: "" + transactionSetupId })))),
            preventCreditCharge && (React.createElement(React.Fragment, null,
                React.createElement(CardContent, null,
                    React.createElement(Box, null,
                        React.createElement(Button, { color: "vitality", disabled: !amount, onClick: function () {
                                return onFinalizePayment({
                                    amount: amount.toString(),
                                    paymentMethod: selectedPaymentMethod,
                                    note: note,
                                });
                            } }, "Finalize Payment"))))))));
}
function CollectPaymentNew(props) {
    var onConfirmTransaction = props.onConfirmTransaction, patient = props.patient, practice = props.practice;
    var dsTheme = getDesignSystemTheme();
    var _a = useSavedCards({
        patientId: patient.patientId,
    }), cards = _a.cards, isCardListFetching = _a.isLoading, deleteCard = _a.deleteCard;
    var _b = useReducer(function (state, action) {
        // if specifically unchecked, we'll clear out the fields
        if (action.isCheckedSaveCard === false) {
            return {
                isCheckedSaveCard: false,
                cardDescription: undefined,
                cardNickname: undefined,
            };
        }
        return __assign(__assign({}, state), action);
    }, {
        isCheckedSaveCard: false,
        cardDescription: undefined,
        cardNickname: undefined,
    }), saveCardState = _b[0], setSaveCardState = _b[1];
    var _c = useState(false), isNewCardFormOpen = _c[0], setIsNewCardFormOpen = _c[1];
    var _d = useState(false), isUsingTerminalPayOption = _d[0], _setIsUsingTerminalPayOption = _d[1];
    var _e = useState(null), selectedTerminal = _e[0], setSelectedTerminal = _e[1];
    var _f = useState(null), selectedCard = _f[0], _setSelectedCard = _f[1];
    function setSelectedCard(card) {
        _setSelectedCard(card);
        if (card !== null) {
            setIsUsingTerminalPayOption(false);
        }
    }
    function setIsUsingTerminalPayOption(enabled) {
        _setIsUsingTerminalPayOption(enabled);
        if (enabled) {
            _setSelectedCard(null);
        }
        if (!enabled) {
            setSelectedTerminal(null);
        }
    }
    var _g = useState({ userGuid: '' }), user = _g[0], setUser = _g[1];
    var _h = useState(false), isProcessingTransaction = _h[0], setIsProcessingTransaction = _h[1];
    var _j = useState(null), errorConfig = _j[0], setErrorConfig = _j[1];
    var _k = useState(false), showSnackbarError = _k[0], setShowSnackbarError = _k[1];
    var _l = useState(null), error = _l[0], _setError = _l[1];
    function setError(newErr) {
        _setError(newErr);
        if (newErr === null) {
            setErrorConfig(null);
            return;
        }
        if (newErr instanceof TebraTerminalError) {
            // create new Error to avoid modifying newErr reference
            //  because otherwise it will modify message instead of note
            var loggingError = new Error(newErr.note || newErr.message);
            rollbar.error(loggingError);
            switch (newErr.errorType) {
                case TebraTerminalErrorType.CANCELED:
                    setErrorConfig(null);
                    setShowSnackbarError(true);
                    break;
                case TebraTerminalErrorType.TIMED_OUT:
                    setErrorConfig({ severity: 'warning', variant: 'standard' });
                    setShowSnackbarError(false);
                    break;
                case TebraTerminalErrorType.TRANSACTION_FAILED:
                case TebraTerminalErrorType.FETCH_FAILED:
                    document.body.scrollTo({ top: 0 });
                    setErrorConfig({ severity: 'error', variant: 'filled' });
                    setShowSnackbarError(false);
                    break;
                case TebraTerminalErrorType.GENERIC:
                default:
                    setErrorConfig(null);
                    setShowSnackbarError(false);
                    break;
            }
        }
        else {
            setErrorConfig({ severity: 'error', variant: 'filled' });
            rollbar.error(newErr);
        }
    }
    useEffect(function () {
        authenticatedUser.getAuthenticatedUser().then(function (resp) {
            setUser(resp);
        });
    }, []);
    useEffect(function () {
        window.addEventListener('message', function (event) {
            if (event.origin.match(/api-payments-svcs.cloud.tebra.com/i) === null) {
                return;
            }
            var response = event.data.response;
            var errorObj = response.error;
            var status = response.status;
            // check if status is any of the failure statuses
            var respStatus = status.toUpperCase();
            if (!FailedTransactionStatuses.has(respStatus)) {
                onConfirmTransaction(event.data);
                setError(null);
                return;
            }
            // if it is, set the error message
            var errorMessage = errorObj === null || errorObj === void 0 ? void 0 : errorObj.message;
            var hasMessage = errorMessage !== '' && errorMessage !== undefined;
            setError(new Error(hasMessage
                ? errorMessage
                : 'Card Declined: Invalid Credit Card Information. Please check the billing address and/or credit card information.'));
        });
    }, []);
    return (React.createElement(ThemeProvider, { theme: dsTheme },
        React.createElement(CardDetailsContext.Provider, { value: {
                patient: patient,
                practice: practice,
                user: user,
                cards: cards,
                isCardListFetching: isCardListFetching,
                selectedCard: selectedCard,
                setSelectedCard: setSelectedCard,
                error: error,
                setError: setError,
                isProcessingTransaction: isProcessingTransaction,
                setIsProcessingTransaction: setIsProcessingTransaction,
                saveCardState: saveCardState,
                setSaveCardState: setSaveCardState,
                isNewCardFormOpen: isNewCardFormOpen,
                setIsNewCardFormOpen: setIsNewCardFormOpen,
                selectedTerminal: selectedTerminal,
                setSelectedTerminal: setSelectedTerminal,
                isUsingTerminalPayOption: isUsingTerminalPayOption,
                setIsUsingTerminalPayOption: setIsUsingTerminalPayOption,
                deleteCard: deleteCard,
            } },
            error !== null && errorConfig !== null && (React.createElement(Box, { marginBottom: 1, clone: true },
                React.createElement(Alert, __assign({}, errorConfig), (error === null || error === void 0 ? void 0 : error.message) ||
                    'Transaction failed, check your payment details and try again. If the issue persists, please contact our support team for assistance.'))),
            React.createElement(Snackbar, { open: showSnackbarError, onClose: function () { return setShowSnackbarError(false); }, type: "info", message: error === null || error === void 0 ? void 0 : error.message, autoHideDuration: 5000 }),
            React.createElement(CollectPaymentComponent, __assign({}, props)))));
}
function CollectPaymentComponent(props) {
    var patient = props.patient, patientBalance = props.patientBalance, address1 = props.address1, zip = props.zip, onUpdateNote = props.onUpdateNote, onFinalizePayment = props.onFinalizePayment;
    var _a = useContext(CardDetailsContext), isUsingTerminalPayOption = _a.isUsingTerminalPayOption, selectedCard = _a.selectedCard, setSelectedCard = _a.setSelectedCard, selectedTerminal = _a.selectedTerminal, setIsUsingTerminalPayOption = _a.setIsUsingTerminalPayOption, practice = _a.practice, user = _a.user, error = _a.error, setError = _a.setError, setIsProcessingTransaction = _a.setIsProcessingTransaction, saveCardState = _a.saveCardState;
    var isCheckedSaveCard = saveCardState.isCheckedSaveCard, cardNickname = saveCardState.cardNickname, cardDescription = saveCardState.cardDescription;
    var _b = useState(Number(patientBalance).toString()), amount = _b[0], setAmount = _b[1];
    var _c = useState(Number(patientBalance !== null && patientBalance !== void 0 ? patientBalance : 0).toFixed(2)), pendingAmount = _c[0], setPendingAmount = _c[1];
    var _d = useState('credit'), selectedPaymentMethod = _d[0], setSelectedPaymentMethod = _d[1];
    var _e = useState(false), preventCreditCharge = _e[0], setPreventCreditCharge = _e[1];
    var _f = useState(''), note = _f[0], setNote = _f[1];
    var _g = useState(false), showingNote = _g[0], setShowingNote = _g[1];
    var _h = useState(true), billingAddressSameAsPatientAddress = _h[0], setBillingAddressSameAsPatientAddress = _h[1];
    var _j = useState(address1), billingAddress1 = _j[0], setBillingAddress1 = _j[1];
    var _k = useState(zip), billingZip = _k[0], setBillingZip = _k[1];
    var _l = useState(props.name), name = _l[0], setName = _l[1];
    var _m = useState(false), isTerminalProcessingModalOpen = _m[0], setIsTerminalProcessingModalOpen = _m[1];
    var _o = useState(false), isTebraPayFacPassThroughOnly = _o[0], setIsTebraPayFacPassThroughOnly = _o[1];
    var handleChangePaymentMethod = useCallback(function (event) {
        var newValue = event.target.value;
        if (newValue === selectedPaymentMethod)
            return;
        setSelectedPaymentMethod(newValue);
        if (newValue !== 'credit') {
            // this hides the Card Form
            setPreventCreditCharge(true);
        }
        else {
            setSelectedCard(null);
            setIsUsingTerminalPayOption(false);
        }
    }, [selectedPaymentMethod, setSelectedPaymentMethod]);
    var handleChangePreventCreditCharge = useCallback(function (event) {
        setPreventCreditCharge(event.target.checked);
    }, [setPreventCreditCharge]);
    useEffect(function () {
        featureToggles
            .isEnabled(FeatureToggles.TEBRA_PAYFAC_PASS_THROUGH_ONLY)
            .then(function (response) {
            setIsTebraPayFacPassThroughOnly(!!response);
        });
    }, []);
    var resetBillingAddress = useCallback(function () {
        setBillingAddressSameAsPatientAddress(true);
        setBillingAddress1(address1);
        setBillingZip(zip);
        setName(name);
    }, [address1, zip, name]);
    var handleChangeBillingAddressSame = useCallback(function (event) {
        var checked = event.target.checked;
        if (checked) {
            resetBillingAddress();
        }
        setBillingAddressSameAsPatientAddress(checked);
    }, [setBillingAddressSameAsPatientAddress, resetBillingAddress]);
    // this should be optimized to not be re-ran every time things change even when iframe isn't even used
    var transactionOptions = useMemo(function () {
        var address = typeof billingAddress1 === 'string' ? billingAddress1 : '';
        var zip = typeof billingZip === 'string' ? billingZip : '';
        var charge = typeof amount === 'string' ? amount : '0.00';
        return {
            amount: formatAmount(charge),
            billingAddress1: address !== null && address !== void 0 ? address : '',
            billingZipcode: zip !== null && zip !== void 0 ? zip : '',
            cardAccountId: patient.patientId,
            name: name !== null && name !== void 0 ? name : '',
            paymentType: isCheckedSaveCard ? 4 : undefined,
            saveCard: isCheckedSaveCard || false,
            submissionType: isCheckedSaveCard ? 1 : undefined,
            metadata: {
                note: note,
                patientId: patient.patientId,
                userGuid: user.userGuid,
                paymentScenario: 'webapp',
                paymentScenarioV2: '[tpay-webapp-facesheet-cardNotPresent]',
            },
        };
    }, [amount, billingAddress1, billingZip, isCheckedSaveCard, error]);
    function onClickProcessTransaction() {
        setError(null);
        var hasSelectedTerminal = isUsingTerminalPayOption && selectedTerminal !== null;
        if (hasSelectedTerminal) {
            setIsProcessingTransaction(true);
            // opening the modal kicks off the transaction process
            setIsTerminalProcessingModalOpen(true);
            return;
        }
        if (selectedCard !== null) {
            handleProcessSavedCardPayment();
        }
    }
    function handleProcessSavedCardPayment() {
        return __awaiter(this, void 0, void 0, function () {
            var options, cofTransactionURL, transactionResp, recordRequest, recordResp, err_1, errorCOF;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (selectedCard === null)
                            return [2 /*return*/];
                        setIsProcessingTransaction(true);
                        setError(null);
                        options = {
                            amount: formatAmount(amount),
                            applicationId: portal.AppId,
                            cardId: selectedCard.cardId,
                            cardAccountId: patient.patientId,
                            name: patient.name,
                            patientId: patient.patientId,
                            paymentType: 4,
                            practiceExternalId: (practice.customerId || practice.practiceGuid).toString(),
                            submissionType: 2,
                            isExternalId: true,
                            metadata: {
                                note: note,
                                patientId: patient.patientId,
                                userGuid: user.userGuid,
                                paymentScenario: 'webapp',
                                paymentScenarioV2: '[tpay-webapp-facesheet-cardOnFile]',
                            },
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 6]);
                        cofTransactionURL = isTebraPayFacPassThroughOnly
                            ? '/payments-ui/api/PatientPay/payments-orchestrator-service/api/transactions/chargecard'
                            : "/payments-ui/api/PatientPay/transactions/cards/" + (selectedCard === null || selectedCard === void 0 ? void 0 : selectedCard.cardId);
                        return [4 /*yield*/, kfetch(cofTransactionURL, {
                                method: 'POST',
                                body: JSON.stringify(options),
                            })];
                    case 2:
                        transactionResp = _a.sent();
                        recordRequest = {
                            cardInHand: false,
                            paymentFacilitationType: 'hosted-platform-payment',
                            referenceId: transactionResp.referenceId,
                            amount: formatAmount(isTebraPayFacPassThroughOnly
                                ? transactionResp.approvedAmount
                                : transactionResp.amount),
                            patientId: patient.patientId,
                            note: note,
                        };
                        return [4 /*yield*/, kfetch('/payments-ui/api/PatientPayment/hosted-payments', {
                                method: 'POST',
                                body: JSON.stringify(recordRequest),
                            }).catch(function () {
                                // this is to differentiate from `/transactions` errors
                                //  in https://kareodev.atlassian.net/browse/PAY-2304 we will continue
                                //  to the receipt page even if this has an error
                                return new Error('POSTED_PAYMENTS_ERROR');
                            })];
                    case 3:
                        recordResp = _a.sent();
                        props.onConfirmTransactionCOF(transactionResp, recordResp);
                        return [3 /*break*/, 6];
                    case 4:
                        err_1 = _a.sent();
                        rollbar.error(err_1);
                        errorCOF = new Error('Payment could not be processed. Try using a different card if this error persists.');
                        setError(errorCOF);
                        return [3 /*break*/, 6];
                    case 5:
                        setIsProcessingTransaction(false);
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    }
    // -- start Tebra Terminal Pay functions
    function getTransactionParams() {
        if (selectedTerminal === null ||
            selectedTerminal.connectionStatus !== TerminalConnectionStatus.OPEN) {
            throw new TebraTerminalError(undefined, 'Invalid Terminal selected');
        }
        return {
            name: name !== null && name !== void 0 ? name : '',
            cardAccountId: String(patient.patientId),
            laneId: selectedTerminal.laneId,
            transactionAmount: formatAmount(amount),
            billingAddress1: billingAddress1 !== null && billingAddress1 !== void 0 ? billingAddress1 : '',
            billingZipcode: zip !== null && zip !== void 0 ? zip : '',
            saveCard: isCheckedSaveCard || false,
            cardDescription: cardDescription,
            cardNickname: cardNickname,
            metadata: {
                note: note,
                patientId: String(patient.patientId),
                userGuid: user.userGuid,
                paymentScenario: 'webapp terminal',
                paymentScenarioV2: '[tpay-webapp-facesheet-cardPresent]',
            },
        };
    }
    function handleCreateTerminalTransaction() {
        setIsProcessingTransaction(true);
        try {
            return createTerminalTransaction(getTransactionParams());
        }
        catch (err) {
            setIsProcessingTransaction(false);
            throw err;
        }
    }
    function getHostedParams(transactionResp) {
        if (transactionResp === undefined) {
            throw new TebraTerminalError(undefined, 'GET transaction status polling returned an empty response', TebraTerminalErrorType.TRANSACTION_FAILED);
        }
        return {
            name: patient.name || '',
            referenceId: transactionResp.transactionReferenceId,
            amount: formatAmount(transactionResp.transactionAmount),
            patientId: patient.patientId,
            cardInHand: true,
            paymentFacilitationType: 'hosted-platform-payment',
            note: note,
        };
    }
    function handleCreateHostedPayments(transactionResp) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    return [2 /*return*/, finalizeHostedPayment(getHostedParams(transactionResp))];
                }
                catch (err) {
                    throw err;
                }
                return [2 /*return*/];
            });
        });
    }
    function handleCompleteTerminalTransaction(transactionResp, recordResp) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var transactionReceiptData;
            return __generator(this, function (_d) {
                setIsProcessingTransaction(false);
                setIsTerminalProcessingModalOpen(false);
                transactionReceiptData = {
                    name: practice.name,
                    amount: receiptUtils.formatAmount((_a = transactionResp.approvedAmount) !== null && _a !== void 0 ? _a : '0.00'),
                    merchantId: transactionResp.merchantId,
                    paymentMethod: receiptUtils.formatPaymentMethod(transactionResp),
                    transactionType: 'Purchase',
                    transactionDateTime: receiptUtils.formatDateForReceipt((_b = transactionResp.transactionDateTime) !== null && _b !== void 0 ? _b : ''),
                    confirmationNumber: transactionResp.transactionReferenceId,
                    hostResponse: transactionResp.hostResponseCode + "/" + transactionResp.expressResponseMessage,
                    approvalNumber: (_c = transactionResp.approvalNumber) !== null && _c !== void 0 ? _c : '',
                    applicationIdentifier: transactionResp.applicationIdentifier,
                    applicationPreferredName: transactionResp.applicationPreferredName,
                    cryptogram: transactionResp.cryptogram,
                };
                props.onConfirmTransactionTebraTerminal(transactionResp, recordResp, transactionReceiptData);
                return [2 /*return*/];
            });
        });
    }
    // -- end Tebra Terminal Pay functions
    var isGenericError = function () {
        if (error === null) {
            return false;
        }
        if (error instanceof TebraTerminalError) {
            return error.errorType === TebraTerminalErrorType.GENERIC;
        }
        return true;
    };
    var isAmountEmpty = !Boolean(amount) || Number(amount) === 0;
    return (React.createElement(Card, null,
        React.createElement(CardContent, null,
            React.createElement(Box, null,
                React.createElement(Typography, { variant: "h3" }, "Collect Payment"),
                React.createElement(Form, { noValidate: true, autoComplete: "off" },
                    React.createElement(Box, { display: "block" },
                        React.createElement(FeatureToggle, { if: "dark-feature.tebra-payfac-amount-formatting" },
                            React.createElement(TextField, { "data-testid": "collect-payment-amount", value: pendingAmount, label: "Amount", type: "text", margin: "dense", inputProps: {
                                    inputMode: 'decimal',
                                }, onChange: function (e) {
                                    setPendingAmount(e.target.value);
                                }, onBlur: function () {
                                    var newAmount = formatAmount(pendingAmount);
                                    setPendingAmount(newAmount);
                                    setAmount(newAmount);
                                } })),
                        React.createElement(FeatureToggle, { if: "!dark-feature.tebra-payfac-amount-formatting" },
                            React.createElement(TextField, { value: pendingAmount, label: "Amount", type: "text", margin: "dense", inputProps: {
                                    inputMode: 'decimal',
                                }, onChange: function (e) {
                                    setPendingAmount(e.target.value);
                                }, onBlur: function () {
                                    var amountString = Number(pendingAmount !== null && pendingAmount !== void 0 ? pendingAmount : 0).toFixed(2);
                                    var newAmount = isNaN(Number(amountString))
                                        ? '0.00'
                                        : amountString;
                                    setPendingAmount(newAmount);
                                    setAmount(Number(newAmount).toString());
                                } }))),
                    React.createElement(Box, { display: "block" },
                        !showingNote && (React.createElement(ButtonWithBlueText, { variant: "text", startIcon: React.createElement(NoteAddIcon, null), onClick: function () { return setShowingNote(true); } }, "Add Payment Note")),
                        showingNote && (React.createElement(Box, null,
                            React.createElement(Box, { display: "flex", flexDirection: "column", alignItems: "flex-start" },
                                React.createElement(ButtonWithBlueText, { variant: "text", startIcon: React.createElement(NoteAddIcon, null), onClick: function () {
                                        onUpdateNote('');
                                        setShowingNote(false);
                                    } }, "Remove Note"),
                                React.createElement(NoteTextArea, { multiline: true, value: note, onChange: function (event) {
                                        var value = event.target.value;
                                        setNote(value);
                                        onUpdateNote(value);
                                    } }),
                                React.createElement(Typography, { variant: "caption" }, "This note is only visible to the practice.")))))))),
        React.createElement(CardDivider, null),
        React.createElement(CardContent, null,
            React.createElement(Typography, { variant: "h3" }, "Payment Method"),
            React.createElement(FormControl, { component: "fieldset" },
                React.createElement(RadioGroup, { row: true, "aria-label": "selected-payment-method", name: "selectedPaymentMethod", value: selectedPaymentMethod, onChange: handleChangePaymentMethod },
                    React.createElement(FormControlLabel, { "data-testid": "credit-radio-button", labelPlacement: "end", value: "credit", control: React.createElement(Radio, null), label: "Credit Card" }),
                    React.createElement(FormControlLabel, { "data-testid": "cash-radio-button", labelPlacement: "end", value: "cash", control: React.createElement(Radio, null), label: "Cash" }),
                    React.createElement(FormControlLabel, { "data-testid": "check-radio-button", labelPlacement: "end", value: "check", control: React.createElement(Radio, null), label: "Check" })),
                selectedPaymentMethod === 'credit' && (React.createElement(React.Fragment, null,
                    React.createElement(FormGroup, null,
                        React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: preventCreditCharge, onChange: handleChangePreventCreditCharge }), label: "Do not charge credit card. For recording purposes only." })))))),
        React.createElement(CardDivider, null),
        React.createElement(CardContent, null,
            React.createElement(Typography, { variant: "h3" }, "Billing Address"),
            React.createElement(React.Fragment, null,
                React.createElement(FormGroup, null,
                    React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { checked: billingAddressSameAsPatientAddress, onChange: handleChangeBillingAddressSame }), label: "Billing address is same as patient address" })),
                !billingAddressSameAsPatientAddress && (React.createElement(BillingAddressForm, null,
                    React.createElement(TextField, { margin: "dense", label: "Address", defaultValue: address1 }),
                    React.createElement(TextField, { margin: "dense", label: "Zip", defaultValue: zip, inputProps: { maxLength: 5 } }))))),
        React.createElement(CardDivider, null),
        !preventCreditCharge && (React.createElement(CardDetailsSection, { onClickProcessTransaction: onClickProcessTransaction, transactionOptions: transactionOptions, isAmountEmpty: isAmountEmpty, handleCreateTerminalTransaction: handleCreateTerminalTransaction, handleCompleteTerminalTransaction: handleCompleteTerminalTransaction, handleCreateHostedPayments: handleCreateHostedPayments, isTerminalProcessingModalOpen: isTerminalProcessingModalOpen, setIsTerminalProcessingModalOpen: setIsTerminalProcessingModalOpen })),
        preventCreditCharge && (React.createElement(CardContent, null,
            React.createElement(Box, null,
                React.createElement(Button, { color: "vitality", disabled: isAmountEmpty, onClick: function () {
                        return onFinalizePayment({
                            amount: amount,
                            paymentMethod: selectedPaymentMethod,
                            note: note,
                        });
                    } }, "Finalize Payment")))),
        React.createElement(CardContent, { style: { paddingTop: 0 } },
            isGenericError() && (React.createElement(Box, { marginBottom: 2 },
                React.createElement(Alert, { severity: "error" }, error === null || error === void 0 ? void 0 : error.message))),
            React.createElement(Alert, { severity: "info" }, "Important: It may take up to 15 minutes for the transaction to appear on the transactions table. Please do not retry processing the transaction after clicking 'Process Transaction' once. Multiple attempts may result in multiple charges to your customers."))));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
